import { AvailableValidationReport } from "../../models";

export interface GetAvailableReportsResponse {
    data: AvailableValidationReport[];
}
